import * as React from 'react'
import { cn } from '../../lib/utils'

/**
 * The change-kind palette shared by every diff surface: green for additions,
 * amber for modifications, red for removals, brand for conflicts, muted for
 * informational rows. One place, so the ingest diff, the merge diff, and the
 * commit history always speak the same color language.
 */
export type DiffTone = 'add' | 'change' | 'remove' | 'conflict' | 'neutral'

export const DIFF_TONE_CLASSES: Record<DiffTone, string> = {
  add: 'bg-st-run-bg text-st-run',
  change: 'bg-st-warn-bg text-st-warn',
  remove: 'bg-st-down-bg text-st-down',
  conflict: 'bg-brand-soft text-brand',
  neutral: 'bg-bg-sunk text-ink-3'
}

/** The compact colored kind label at the start of a diff row. */
export function KindBadge({
  tone,
  className,
  children
}: {
  tone: DiffTone
  className?: string
  children: React.ReactNode
}) {
  return (
    <span
      className={cn(
        'inline-flex rounded-sm px-1.5 text-10 font-medium tracking-wide uppercase',
        DIFF_TONE_CLASSES[tone],
        className
      )}
    >
      {children}
    </span>
  )
}
